import React, { FC, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ProjectConversationId, ProjectId } from 'api/models';
import {
  ProjectConversation,
  ProjectConversationFormPayload,
  UpdateConversationFormItems,
} from 'api/project-conversations';
import { PermissionRuleName } from 'constant';
import { usePermissionForRule } from 'hooks/permissions/use-permission';
import { useCreateProjectConversationsMutation } from 'queries/project-wide-conversation';
import { getProjectConversationDetailUrl } from 'utils/urls';
import { ConversationForm } from '../../conv-form';

interface NewConversationFormProps {
  onSuccess: () => void;
  loading?: boolean;
}

export const NewConversationForm: FC<NewConversationFormProps> = (props) => {
  const { onSuccess } = props;
  const history = useHistory();

  const { projectId: projectIdFromRoute } = useParams<{ projectId: string }>();
  const projectId = Number(projectIdFromRoute);

  const initialValues: ProjectConversationFormPayload = useMemo(() => {
    return {
      conversationName: '',
      conversationDescription: '',
      private: false,
      addAllMemberToChannel: false,
      projectId,
    };
  }, [projectId]);

  const {
    mutate: newConversationMutate,
    isLoading: isNewConversationCreationLoading,
  } = useCreateProjectConversationsMutation(ProjectId(projectId));

  const onSubmit = (form) => {
    const formData = form.getFieldsValue(true);

    newConversationMutate(
      {
        conversationName:
          formData[UpdateConversationFormItems.ConversationName],
        conversationDescription:
          formData[UpdateConversationFormItems.ConversationDescription],
        private: formData[UpdateConversationFormItems.Private],
        addAllMemberToChannel:
          formData[UpdateConversationFormItems.AddAllMemberToChannel],
        project: {
          projectId: formData[UpdateConversationFormItems.ProjectId],
        },
      },
      {
        onSuccess: (newConversation: ProjectConversation) => {
          history.push(
            getProjectConversationDetailUrl(
              ProjectId(newConversation.project.projectId),
              ProjectConversationId(newConversation.conversationId),
            ),
          );
          form.resetFields();
          if (onSuccess) {
            onSuccess();
          }
        },
      },
    );
  };
  const { isAllowedForCurrentUser } = usePermissionForRule();

  return (
    <ConversationForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      name="newConversationForm"
      hidePrivateCheckbox={
        !isAllowedForCurrentUser(
          PermissionRuleName.ProjectChatPrivateCreateAction,
        )
      }
      loading={isNewConversationCreationLoading}
    />
  );
};
